import type React from "react";

const About: React.FC = () => {
	return (
		<section className="py-16 md:py-24 bg-white">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="text-center mb-12">
					<h2 className="text-3xl md:text-4xl font-bold mb-4">
						学習ギルドとは
					</h2>
					<p className="text-lg text-gray-600 max-w-3xl mx-auto">
						大船渡学習ギルドは、地域の人々が集まり、共に学び、成長するためのコミュニティです。
						プログラミング、デザイン、語学など、様々な分野での学習をサポートし、
						メンバー同士の交流を通じて、互いに刺激し合える環境を提供しています。
					</p>
				</div>

				<div className="grid md:grid-cols-3 gap-8">
					<div className="text-center p-6">
						<div className="text-4xl mb-4">🤝</div>
						<h3 className="text-xl font-semibold mb-2">共に学ぶ</h3>
						<p className="text-gray-600">
							一人じゃない。仲間と一緒に学ぶことで、モチベーションを維持できます。
						</p>
					</div>
					<div className="text-center p-6">
						<div className="text-4xl mb-4">💡</div>
						<h3 className="text-xl font-semibold mb-2">知識の共有</h3>
						<p className="text-gray-600">
							お互いの知識や経験を共有し、新しい視点や気づきを得られます。
						</p>
					</div>
					<div className="text-center p-6">
						<div className="text-4xl mb-4">🌱</div>
						<h3 className="text-xl font-semibold mb-2">継続的な成長</h3>
						<p className="text-gray-600">
							定期的なイベントやフィードバックで、着実な成長を実現します。
						</p>
					</div>
				</div>
			</div>
		</section>
	);
};

export default About;
